import {
  CONNECTION_ANALYSIS_TOGGLE,
  CONNECTION_ADD_FEATURE_POINT,
  CONNECTION_DELETE_POINT,
  CONNECTION_SET_FEATURE_ENDING,
  CONNECTION_END_DRAWING,
  CONNECTION_ADD_FEATURE_POINT_MANUALLY,
  CONNECTION_POINT_CHANGED,
  WINDOW_NOTIFICATION_SHOW
} from './mutations.type';

import { CONNECTION_GENERATE_REPORT } from './actions.type';

import { Api as ApiAnalizy } from '../api/api-analizy';
import { Api as ApiReport } from '../api/api-raporty';
import SettingsInstance from '../api/SettingsInstance';
import AuthInstance from '../api/ContextInstance';
import GeoJSONFormat from 'ol/format/GeoJSON';
import { LineString, Point } from 'ol/geom';
import Feature from 'ol/Feature';

const state = {
  launched: false,
  drawingEnded: false,
  pointAdded: false,
  drawnFeature: null,
  waitingForResponse: false
};

const actions = {
  async [CONNECTION_GENERATE_REPORT]({ state, rootGetters, commit }, buffor) {
    try {
      const copyOfGeometry = state.drawnFeature.getGeometry().clone();
      copyOfGeometry.transform(rootGetters.coordinateSystem, 'EPSG:2180');
      const geometry = new GeoJSONFormat().writeGeometryObject(copyOfGeometry);

      const analysisApi = new ApiAnalizy();
      const response = await analysisApi.postAnalizyDostepInternetuGeometria({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        body: { distance: buffor, geometry: geometry }
      });

      if (response.body.raport) {
        const reportId = response.body.raport.id;

        const reportsApi = new ApiReport();

        let intervalId = setTimeout(async function askForStatus() {
          const control = Date.now().toString();
          const result = await reportsApi.getRaportyById({
            control: control,
            id: reportId
          });

          if (result && result.body && result.body.control == control) {
            if (result.body.raporty.status.value == 'generated') {
              const downloadUrl = `${SettingsInstance.baseApiUrl}/raporty/by_uuid/${result.body.raporty.uuid}`;
              window.open(downloadUrl, '_blank');
            } else {
              intervalId = setTimeout(askForStatus, 10000);
            }
          }
        }, 0);
      }
    } catch (err) {
      commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'error',
        title: 'Uwaga.',
        message: 'Analiza nie powiodła się.',
        duration: 5000
      });
    }
  }
};

const mutations = {
  [CONNECTION_ANALYSIS_TOGGLE](state) {
    state.launched = !state.launched;

    if (state.launched) {
      state.drawnFeature = new Feature();
    } else {
      state.drawingEnded = state.pointAdded = state.waitingForResponse = false;
      state.drawnFeature = null;
    }
  },
  [CONNECTION_ADD_FEATURE_POINT](state, pointCoordinates) {
    if (!state.launched || state.drawingEnded) {
      return;
    }

    if (state.pointAdded) {
      state.drawingEnded = true;
    } else {
      const featureGeometry = state.drawnFeature.getGeometry();

      if (featureGeometry) {
        const coordinates = featureGeometry.getCoordinates();
        const lastPoint = coordinates[coordinates.length - 2];

        if (
          lastPoint[0] != pointCoordinates[0] ||
          lastPoint[1] != pointCoordinates[1]
        ) {
          state.pointAdded = true;
        }
      } else {
        state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
        state.pointAdded = true;
      }
    }
  },
  [CONNECTION_ADD_FEATURE_POINT_MANUALLY](state, pointCoordinates) {
    if (!state.launched) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      featureGeometry.appendCoordinate(pointCoordinates);
    } else {
      state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
    }

    state.pointAdded = true;
  },
  [CONNECTION_POINT_CHANGED](state, { index, coordinates }) {
    const featureGeometry = state.drawnFeature.getGeometry();
    const featureCoordinates = featureGeometry.getCoordinates();
    featureCoordinates[index] = coordinates;
    featureGeometry.setCoordinates(featureCoordinates);
  },
  [CONNECTION_DELETE_POINT](state, index) {
    const drawnFeatureCoordinates = state.drawnFeature
      .getGeometry()
      .getCoordinates();
    drawnFeatureCoordinates.splice(index, 1);
    state.drawnFeature.getGeometry().setCoordinates(drawnFeatureCoordinates);
    state.pointAdded = true;
  },
  [CONNECTION_SET_FEATURE_ENDING](state, endPointCoordinates) {
    if (!state.launched || state.drawingEnded) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      if (state.pointAdded) {
        featureGeometry.appendCoordinate(endPointCoordinates);
        state.pointAdded = false;
      } else {
        const coordinates = featureGeometry.getCoordinates();
        coordinates[coordinates.length - 1] = endPointCoordinates;
        featureGeometry.setCoordinates(coordinates);
      }
    }
  },
  [CONNECTION_END_DRAWING](state) {
    state.drawingEnded = true;
  }
};

const getters = {
  connectionAnalysisLaunched: state => state.launched,
  connectionAnalysisFeature: state => state.drawnFeature,
  connectionanalysisDrawingEnded: state => state.drawingEnded
};

export default {
  state,
  actions,
  mutations,
  getters
};
